var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64C50.1731 64 64.5 49.6731 64.5 32C64.5 14.3269 50.1731 0 32.5 0C14.8269 0 0.5 14.3269 0.5 32C0.5 49.6731 14.8269 64 32.5 64ZM46.4807 24.4592C47.0877 23.8954 47.1229 22.9464 46.5592 22.3393C45.9955 21.7322 45.0464 21.6971 44.4393 22.2608L25.3386 39.9972L19.1607 33.8193C18.5749 33.2335 17.6251 33.2335 17.0393 33.8193C16.4536 34.4051 16.4536 35.3548 17.0393 35.9406L24.2393 43.1406C24.8099 43.7111 25.7294 43.7282 26.3207 43.1792L46.4807 24.4592Z",
    fill: "#009640"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic_success.e070c54c15e227adb4ce9626489b22fc.svg";
export { ForwardRef as ReactComponent };